<template>
  <div class="top-bar">
    <!-- 左侧：企业名称 + 实时时间 -->
    <div class="top-left">
      <div class="company-info">
        <div class="company-logo">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z"/>
            <path d="M2 17l10 5 10-5"/>
            <path d="M2 12l10 5 10-5"/>
          </svg>
        </div>
        <span class="company-name">时代高科</span>
      </div>
      <div class="realtime-clock">
        <span class="clock-icon">⏱</span>
        <span class="clock-time">{{ currentTime }}</span>
        <span class="clock-date">{{ currentDate }}</span>
      </div>
    </div>

    <!-- 中间：系统标题 -->
    <div class="top-center">
      <h1 class="system-title">
        <span class="title-icon">◈</span>
        <span class="title-text">客户关系管理系统</span>
        <span class="title-icon">◈</span>
      </h1>
      <div class="title-sub">Customer Relationship Management</div>
    </div>

    <!-- 右侧：数据指标 + 按钮 -->
    <div class="top-right">
      <div class="data-cards">
        <div class="data-card">
          <div class="data-value">{{ dataStats.totalCustomers }}</div>
          <div class="data-label">总客户数</div>
        </div>
        <div class="data-card">
          <div class="data-value">{{ dataStats.todayDeals }}</div>
          <div class="data-label">今日成交</div>
        </div>
        <div class="data-card">
          <div class="data-value">{{ dataStats.monthRevenue }}</div>
          <div class="data-label">本月营收(万)</div>
        </div>
      </div>
      <div class="action-buttons">
        <button class="action-btn btn-primary" @click="handleRefresh" title="刷新数据">
          <span class="btn-icon">↻</span>
          <span class="btn-text">刷新数据</span>
        </button>
        <button class="action-btn btn-secondary" @click="handlePushSRM" title="进入SRM">
          <span class="btn-icon">⚙</span>
          <span class="btn-text">进入SRM</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBar',
  data() {
    return {
      currentTime: '',
      currentDate: '',
      timer: null,
      dataStats: {
        totalCustomers: 12847,
        todayDeals: 36,
        monthRevenue: 486.5
      }
    }
  },
  mounted() {
    this.updateTime()
    this.timer = setInterval(this.updateTime, 1000)
    this.simulateDataChange()
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.dataTimer)
  },
  methods: {
    updateTime() {
      const now = new Date()
      this.currentTime = now.toLocaleTimeString('zh-CN', { hour12: false })
      this.currentDate = now.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        weekday: 'short'
      })
    },
    simulateDataChange() {
      this.dataTimer = setInterval(() => {
        this.dataStats.todayDeals = Math.floor(Math.random() * 20) + 30
        this.dataStats.monthRevenue = (Math.random() * 50 + 460).toFixed(1)
      }, 8000)
    },
    handleRefresh() {
      this.$emit('refresh')
      const btn = event.target.closest('.action-btn')
      btn.classList.add('refreshing')
      setTimeout(() => btn.classList.remove('refreshing'), 1000)
    },
    handlePushSRM() {
      this.$router.push('/SRM')
      // this.$emit('settings')
    }
  }
}
</script>

<style lang="scss" scoped>
.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  padding: 0 24px;
  background: linear-gradient(180deg, #102A15 0%, #0d2311 100%);
  border-bottom: 1px solid rgba(76, 175, 80, 0.15);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
  flex-shrink: 0;
  z-index: 100;
  min-width: 0; // 关键：允许flex子项收缩
}

// ===== 左侧 =====
.top-left {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1;
  min-width: 0; // 允许收缩

  .company-info {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;

    .company-logo {
      width: 36px;
      height: 36px;
      background: linear-gradient(135deg, #4CAF50, #2E7D32);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 0 15px rgba(76, 175, 80, 0.3);
      flex-shrink: 0;

      svg {
        width: 22px;
        height: 22px;
        color: #fff;
      }
    }

    .company-name {
      font-size: 18px;
      font-weight: 600;
      color: #e8f5e9;
      letter-spacing: 2px;
      white-space: nowrap;
    }
  }

  .realtime-clock {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 14px;
    background: rgba(76, 175, 80, 0.08);
    border: 1px solid rgba(76, 175, 80, 0.2);
    border-radius: 20px;
    flex-shrink: 0;

    .clock-icon {
      font-size: 14px;
      color: #4CAF50;
    }

    .clock-time {
      font-size: 16px;
      font-weight: 600;
      color: #81C784;
      font-family: 'Courier New', monospace;
      letter-spacing: 1px;
      white-space: nowrap;
    }

    .clock-date {
      font-size: 12px;
      color: #66BB6A;
      border-left: 1px solid rgba(76, 175, 80, 0.3);
      padding-left: 8px;
      white-space: nowrap;
    }
  }
}

// ===== 中间 =====
.top-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1.5;
  min-width: 0; // 允许收缩

  .system-title {
    font-size: 26px;
    font-weight: 700;
    color: #e8f5e9;
    letter-spacing: 6px;
    text-shadow: 0 0 20px rgba(76, 175, 80, 0.3);
    display: flex;
    align-items: center;
    gap: 12px;
    white-space: nowrap;

    .title-icon {
      color: #4CAF50;
      font-size: 18px;
      opacity: 0.8;
      flex-shrink: 0;
    }

    .title-text {
      white-space: nowrap;
    }
  }

  .title-sub {
    font-size: 11px;
    color: #66BB6A;
    letter-spacing: 3px;
    margin-top: 4px;
    opacity: 0.7;
    text-transform: uppercase;
    white-space: nowrap;
  }
}

// ===== 右侧 =====
.top-right {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1;
  justify-content: flex-end;
  min-width: 0; // 允许收缩

  .data-cards {
    display: flex;
    gap: 12px;
    flex-shrink: 0;

    .data-card {
      text-align: center;
      padding: 8px 16px;
      background: rgba(76, 175, 80, 0.06);
      border: 1px solid rgba(76, 175, 80, 0.12);
      border-radius: 10px;
      min-width: 80px;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(76, 175, 80, 0.12);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(76, 175, 80, 0.15);
      }

      .data-value {
        font-size: 20px;
        font-weight: 700;
        color: #81C784;
        font-family: 'Courier New', monospace;
        white-space: nowrap;
      }

      .data-label {
        font-size: 11px;
        color: #66BB6A;
        margin-top: 2px;
        opacity: 0.8;
        white-space: nowrap;
      }
    }
  }

  .action-buttons {
    display: flex;
    gap: 10px;
    flex-shrink: 0;

    .action-btn {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 8px 18px;
      border: none;
      border-radius: 8px;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;
      outline: none;
      white-space: nowrap;
      flex-shrink: 0;

      .btn-icon {
        font-size: 14px;
      }

      .btn-text {
        white-space: nowrap;
      }

      &.btn-primary {
        background: linear-gradient(135deg, #2E7D32, #1B5E20);
        color: #e8f5e9;
        box-shadow: 0 2px 10px rgba(46, 125, 50, 0.3);

        &:hover {
          background: linear-gradient(135deg, #388E3C, #2E7D32);
          box-shadow: 0 4px 16px rgba(46, 125, 50, 0.4);
          transform: translateY(-1px);
        }
      }

      &.btn-secondary {
        background: rgba(255, 255, 255, 0.05);
        color: #a5d6a7;
        border: 1px solid rgba(76, 175, 80, 0.2);

        &:hover {
          background: rgba(76, 175, 80, 0.1);
          border-color: rgba(76, 175, 80, 0.4);
        }
      }

      &.refreshing {
        animation: spin 0.5s linear;
      }
    }
  }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

// ==================== 响应式优化 ====================

// 1400px 以下：缩小标题字号，减小间距
@media (max-width: 1400px) {
  .top-bar {
    padding: 0 16px;
  }

  .top-left {
    gap: 14px;
  }

  .top-center {
    .system-title {
      font-size: 22px;
      letter-spacing: 4px;
      gap: 8px;
    }
  }

  .top-right {
    gap: 14px;

    .data-cards {
      gap: 8px;

      .data-card {
        padding: 8px 12px;
        min-width: 70px;

        .data-value {
          font-size: 18px;
        }
      }
    }

    .action-buttons {
      gap: 8px;

      .action-btn {
        padding: 8px 14px;
      }
    }
  }
}

// 1200px 以下：隐藏英文副标题，进一步缩小
@media (max-width: 1200px) {
  .top-center {
    .title-sub {
      display: none;
    }

    .system-title {
      font-size: 20px;
      letter-spacing: 3px;
    }
  }

  .top-left {
    .company-name {
      font-size: 16px;
    }

    .realtime-clock {
      padding: 6px 10px;

      .clock-date {
        display: none;
      }
    }
  }

  .top-right {
    .data-cards {
      display: none;
    }
  }
}

// 1024px 以下：隐藏数据卡片，按钮只显示图标，隐藏企业名称只保留logo
@media (max-width: 1024px) {
  .top-bar {
    height: 64px;
    padding: 0 12px;
  }

  .top-left {
    .company-name {
      display: none;
    }

    .realtime-clock {
      .clock-icon {
        display: none;
      }
    }
  }

  .top-center {
    .system-title {
      font-size: 18px;
      letter-spacing: 2px;
      gap: 6px;

      .title-icon {
        font-size: 14px;
      }
    }
  }

  .top-right {

    .action-buttons {
      .action-btn {
        padding: 8px;
        border-radius: 8px;

        .btn-text {
          display: none;
        }

        .btn-icon {
          font-size: 16px;
          margin: 0;
        }
      }
    }
  }
}

// 768px 以下：极简模式
@media (max-width: 768px) {
  .top-bar {
    height: 56px;
    padding: 0 10px;
  }

  .top-left {
    gap: 8px;

    .company-logo {
      width: 32px !important;
      height: 32px !important;

      svg {
        width: 18px !important;
        height: 18px !important;
      }
    }

    .realtime-clock {
      padding: 4px 8px;

      .clock-time {
        font-size: 13px;
      }
    }
  }

  .top-center {
    .system-title {
      font-size: 15px;
      letter-spacing: 1px;
      gap: 4px;

      .title-icon {
        display: none;
      }
    }
  }

  .top-right {
    gap: 8px;

    .action-buttons {
      gap: 6px;

      .action-btn {
        padding: 6px;
        border-radius: 6px;
      }
    }
  }
}

// 480px 以下：超小屏幕，只保留logo和标题
@media (max-width: 480px) {
  .top-left {
    .realtime-clock {
      display: none;
    }
  }

  .top-center {
    .system-title {
      font-size: 14px;
    }
  }

  .top-right {
    .action-buttons {
      .btn-secondary {
        display: none;
      }
    }
  }
}
</style>